import type { Tool, ToolContext, ToolPoint } from "./Tool";

export type TextPromptHandler = (
  point: ToolPoint,
  commit: (text: string) => void,
) => void;

export class TextTool implements Tool {
  readonly id = "text";
  private readonly prompt: TextPromptHandler;

  constructor(prompt: TextPromptHandler) {
    this.prompt = prompt;
  }

  onPointerDown(ctx: ToolContext, point: ToolPoint): void {
    this.prompt(point, (text) => {
      const trimmed = text.trim();
      if (!trimmed) return;
      const { ctx: c, color, brushSize } = ctx;
      const fontSize = Math.max(48, brushSize.px * 2.5);
      c.fillStyle = color.hex;
      c.font = `700 ${fontSize}px Quicksand, "Varela Round", system-ui, sans-serif`;
      c.textBaseline = "top";
      c.fillText(trimmed, point.x, point.y);
    });
  }

  onPointerMove(): void {
    /* intentionally empty */
  }

  onPointerUp(): void {
    /* intentionally empty */
  }
}
